import createArrayFacet from '../createArrayFacet';

export default createArrayFacet({
  stateKey: 'highlights',
  itemKey: 'highlights.values',
  sortBy: 'value',
  sortDirection: 'asc',
});
